<template>
    <div class="md-layout text-center">
        <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
            <login-card header-color="green">
                <h4 slot="title" class="title">Log in</h4>
                    <div class="text-red" v-if="error">{{ error }}</div>

                    <md-field class="md-form-group" slot="inputs">
                        <md-icon>email</md-icon>
                        <label>Email...</label>
                        <md-input v-model="email" type="email" class="email-input"></md-input>
                    </md-field>
                    <md-field class="md-form-group" slot="inputs">
                        <md-icon>lock_outline</md-icon>
                        <label>Password...</label>
                        <md-input v-model="password" type="password" class="password-input" v-on:keyup.enter="signin"></md-input>
                    </md-field>
                    <md-button slot="footer" class="md-simple md-success md-lg login-btn" v-on:click="signin" type="submit">
                        Lets Go
                    </md-button>

                    <div class="my-4"><router-link to="/signup" class="link-grey">Sign up</router-link></div>
            </login-card>
        </div>
    </div>
</template>
<script>
import { LoginCard } from "@/components";
export default {
    name: "Login",
    components: {
        LoginCard
    },
    data() {
        return {
            email: '',
            password: '',
            error: ''
        };
    },
    created() {
        this.checkSignedIn()
    },
    updated() {
        this.checkSignedIn()
    },
    methods: {
        signin() {
            this.$http.plain.post('/sessions/start-web', { type: 'admin', email: this.email, password: this.password })
                .then(response => this.signinSuccessful(response))
                .catch(error => {
                    this.signinFailed(error)
                    alert(error.response.data.meta.message)
                })
        },
        signinSuccessful(response) {
            if (!response.data.csrf) {
                this.signinFailed(response);
                return
            }
            localStorage.csrf     = response.data.csrf;
            localStorage.access   = response.data.access;
            localStorage.signedIn = true;
            this.error = '';
            this.$router.replace('/orders')

        },
        signinFailed(error) {
            this.error = (error.response && error.response.data && error.response.data.error) || '';
            delete localStorage.csrf;
            delete localStorage.access;
            delete localStorage.signedIn
        },
        checkSignedIn() {
            if (localStorage.signedIn) {
                this.$router.replace('/orders')
            }
        }
    }
}
</script>

<style></style>
